import * as React from 'react'
import { matchPath, NavLink } from 'react-router-dom'
import styled from 'styled-components'
import ERoute from '../../ERoute'
import { useTranslation } from 'react-i18next'
import Icon, { IconTypes } from '../../../components/Icons/Icon'
import { useSelector } from 'react-redux'
import { AppState } from '../../store'
import { WidgetSpaceType } from '../../../types'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  line-height: 21px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 25px;
  background-color: rgb(255, 255, 255);
  height: 80px;
  padding: 0px;
  width: 100%;
`

const Button = styled(NavLink)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 3px;
  cursor: pointer;
  line-height: 14px;
  text-overflow: clip;
  text-align: center;
  color: rgb(0, 0, 0);
  text-decoration: none;

  svg {
    width: 24px;
    height: 24px;
    margin-bottom: 8px;
    transition: none;
  }

  &.active {
    font-weight: bold;
    color: black;

    svg {
      fill: rgb(0, 0, 0);
    }
  }
`

const IconContainer = styled.div`
  position: relative;
`

const NotificationBadge = styled.div`
  position: absolute;
  line-height: 13px;
  transform: translateX(100%);
  top: -10px;
  right: 10px;
  display: block;
  border-radius: 50%;
  border: 2px solid rgb(255, 255, 255);
`

const NotificationBadgeIndicator = styled.span`
  background: rgb(223, 32, 32);
  display: flex;
  justify-content: center;
  font-size: 11px;
  color: rgb(250, 250, 250);
  font-weight: 700;
  border-radius: 9px;
  width: fit-content;
  min-width: 16px;
  height: 16px;
  box-sizing: border-box;
  line-height: 16px;
  padding: 0px 4px;
`

interface IProps {
  activePath: string
}

const BottomNavigation = (props: IProps) => {
  const { t } = useTranslation()
  const { widget, counters } = useSelector((state: AppState) => state.application)
  const { activePath } = props

  return (
    <Container>
      {widget?.spaces?.filter(space => space.enabled).map((space) => {
        let route: ERoute = null
        let activeIcon: IconTypes = null
        let inactiveIcon: IconTypes = null
        let counter: number = 0
        let visible = true

        switch (space.type) {
          case WidgetSpaceType.HOME:
            route = ERoute.PATH_HOME
            activeIcon = 'messenger-home-active'
            inactiveIcon = 'messenger-home-inactive'
            counter = 0
            break
          case WidgetSpaceType.CONVERSATIONS:
            route = ERoute.PATH_CONVERSATIONS
            activeIcon = 'messenger-conversations-active'
            inactiveIcon = 'messenger-conversations-inactive'
            counter = counters?.unread_conversations || 0
            break
          case WidgetSpaceType.HELP:
            route = ERoute.PATH_HELP
            activeIcon = 'messenger-help-active'
            inactiveIcon = 'messenger-help-inactive'
            counter = 0
            visible = Boolean(widget.help_center_id)
            break
          case WidgetSpaceType.NEWS:
            route = ERoute.PATH_NEWS_OVERVIEW
            activeIcon = 'messenger-news-active'
            inactiveIcon = 'messenger-news-inactive'
            counter = 0
            visible = Boolean(widget.news_center_id)
            break
        }

        if (!visible) return null

        return (
          <Button key={route} to={route}>
            <IconContainer>
              {counter > 0 && <NotificationBadge>
                <NotificationBadgeIndicator>
                  {counter}
                </NotificationBadgeIndicator>
              </NotificationBadge>}
              {matchPath(activePath, { path: route }) && <Icon icon={activeIcon} />}
              {!matchPath(activePath, { path: route }) && <Icon icon={inactiveIcon} />}
            </IconContainer>

            {t(`WidgetSpaceType::${space.type}`)}
          </Button>
        )
      })}
    </Container>
  )
}

export default BottomNavigation